import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  user-select: none;
  padding: 20px 0;
  border-top: 1px solid ${props => props.theme.palette.general.soft};
  border-bottom: 1px solid ${props => props.theme.palette.general.soft};

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    justify-content: center;
  }

  a {
    display: block;
    padding: 0 20px;
    color: ${props => props.theme.palette.general.grey};
    font: ${font('default', 'medium', '15px/1')};
    text-decoration: none;

    &.active {
      color: ${props => props.theme.palette.primary.alpha};
    }
  }

  li {
    cursor: not-allowed;

    &.disabled {
      a {
        pointer-events: none;
      }
    }
  }
`
